export const SPACE_CENTERS = {
  nodes: [
    {
      id: "1",
      uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
      name: "Schmitt Hills Space Center",
      description:
        "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
      latitude: 86.3067,
      longitude: 163.565,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "2",
      uid: "e9d0cd67-a3af-47b0-98fa-d36f300fdc65",
      name: "Darian Mill Space Center",
      description:
        "Reiciendis ipsum necessitatibus. Ratione sapiente hic maiores sunt nihil nihil. Recusandae perspiciatis non necessitatibus velit fuga. Voluptates doloribus nihil iste placeat et ut.",
      latitude: -30.3743,
      longitude: 1.4417,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "3",
      uid: "1cdf4f97-3529-4547-895c-1d2ed19e8142",
      name: "Jordyn Cliff Space Center",
      description:
        "Quis omnis voluptatem est architecto. Officiis dolores deleniti dolor ipsum. Aliquid ut autem distinctio officiis et libero.",
      latitude: -1.5294,
      longitude: 123.616,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "4",
      uid: "ca6be1f8-d31e-4178-967f-f949c1bbeb47",
      name: "Lynch Bridge Space Center",
      description:
        "Deleniti expedita asperiores accusamus. Dolorem qui enim. Aut id libero voluptatum. Sit aut non est.",
      latitude: -3.0257,
      longitude: -145.607,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "5",
      uid: "f6a07589-6232-4069-9a7c-4cd6b3870b7a",
      name: "Brielle Pine Space Center",
      description:
        "Aut nulla error voluptates ut quibusdam voluptatem quas accusamus ullam. Laborum dolorem nihil vel rerum. Autem enim aut laboriosam illum et deleniti ut. Maiores voluptatibus nihil et.",
      latitude: -44.3633,
      longitude: -60.0895,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "6",
      uid: "f23635a7-6c77-4415-a96f-b1772e8b5b50",
      name: "Alfred Ridges Space Center",
      description:
        "Debitis atque nam officiis accusantium enim ullam quia voluptas. Error molestiae aut dignissimos delectus deserunt et explicabo dolor. Eos laborum praesentium recusandae necessitatibus minima porro deserunt itaque cum. Perferendis sequi suscipit et occaecati dolor.",
      latitude: 72.9434,
      longitude: -0.4223,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "7",
      uid: "b1e2ef70-7007-45af-941d-e986bdadef78",
      name: "Antonietta Village Space Center",
      description:
        "Quaerat rem velit optio minus qui. Consectetur molestias vel et labore voluptatum eum sunt. Illo consequatur voluptatem aut maxime odio occaecati. Id pariatur fugit accusantium ex ipsum ad sit et. Et sapiente ut sit beatae ut animi quia. Nam commodi laboriosam porro distinctio error quia cum reprehenderit.",
      latitude: -87.1274,
      longitude: 54.2218,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "8",
      uid: "f1925229-36a4-41c2-9295-54149376d587",
      name: "Wyman Inlet Space Center",
      description:
        "Provident repellendus debitis quidem sit a est velit ipsum expedita. Quo qui id quae. Quo optio corporis rerum optio. Repellendus illo est incidunt officia ea qui optio possimus.",
      latitude: 14.9726,
      longitude: -33.3936,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "9",
      uid: "3dd09310-ab37-4b01-a571-f8b7c5a8446e",
      name: "Minerva Tunnel Space Center",
      description:
        "Id est eum. Officiis soluta sequi sit voluptas ab ipsam in. Et alias quod aperiam minima expedita placeat quia.",
      latitude: -52.6756,
      longitude: -3.6102,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "10",
      uid: "df0a14ec-8481-4240-9132-ba288d7a36ff",
      name: "Citlalli Meadow Space Center",
      description:
        "Architecto et ratione necessitatibus similique voluptatum natus. Dolores voluptatem quaerat fugit itaque inventore voluptatibus distinctio est perferendis. Aperiam ratione facilis quia reiciendis. Fugit officia explicabo tempora adipisci explicabo dolores. Itaque exercitationem corrupti. Voluptas aut sed laudantium in.",
      latitude: -36.227,
      longitude: 54.541,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "11",
      uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
      name: "Schiller Brook Space Center",
      description:
        "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
      latitude: 82.8725,
      longitude: 71.6412,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "12",
      uid: "443578da-fed6-454f-8088-840ebdacc770",
      name: "Della Terrace Space Center",
      description:
        "Voluptatem minus occaecati necessitatibus. Mollitia voluptas consequuntur fuga ducimus quo odio maiores. Dolore tempore repudiandae dignissimos. Quod saepe ea delectus. Consequatur laboriosam optio.",
      latitude: -45.5516,
      longitude: -83.0922,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "13",
      uid: "58b90fac-e37d-4fc5-a996-f410b6cd2ca2",
      name: "Wilkinson Ford Space Center",
      description:
        "Esse amet doloremque nobis. Voluptatibus aliquid provident dolor vel est qui dolores vitae autem. Ea explicabo eaque odio aspernatur voluptates facilis. Inventore corporis tenetur sed voluptatem consequatur rerum in eligendi. Recusandae ut itaque fugit et molestiae voluptas unde. Libero est aut asperiores voluptatem blanditiis sed nesciunt odio porro.",
      latitude: -76.2075,
      longitude: 100.869,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "14",
      uid: "274208ee-9f2c-4bf2-9ecf-f6f47bbecb3c",
      name: "Wilbert Lodge Space Center",
      description:
        "Ad ea et nihil sit ea deserunt libero. Non et asperiores eos omnis. Ratione quo aut cumque magnam officia repellendus. Quis eum qui.",
      latitude: 11.4333,
      longitude: 158.796,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "15",
      uid: "6844b802-a99c-4c1a-bf70-71ba5cc730cf",
      name: "Leffler Estates Space Center",
      description:
        "Quisquam dicta odit. Quam qui omnis quod accusamus nemo. Autem sunt dolor explicabo est sapiente consectetur ipsa.",
      latitude: 65.9017,
      longitude: -90.3819,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "16",
      uid: "0a05443c-1a80-4992-8297-208e347192ad",
      name: "Hilbert Port Space Center",
      description:
        "Voluptatum consequatur dolorem consequatur porro rerum corporis rerum excepturi qui. Et eum nostrum corrupti id odio rerum commodi velit odit. Et officiis molestiae facilis veritatis error ut consequuntur ut harum.",
      latitude: 30.9182,
      longitude: 90.491,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "17",
      uid: "e03557df-7b6e-4472-b15e-3126bbe7e3c9",
      name: "Trent Divide Space Center",
      description:
        "Eligendi nihil quae unde excepturi nesciunt. Quae sint vel. Voluptas voluptas voluptatibus sint vel harum doloribus perferendis eaque velit. Non ea iusto et esse. Laborum tenetur enim ab aspernatur.",
      latitude: 30.1487,
      longitude: 138.691,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "18",
      uid: "836a837f-85a4-4aec-8f8f-d4f5bef2bb1e",
      name: "Cayla Plain Space Center",
      description:
        "Maxime corporis voluptatibus et. Quia exercitationem at fugiat omnis ea temporibus non nesciunt. Alias eum occaecati aut magni iure tenetur eum. Earum quaerat dolorem accusantium animi. Aut cupiditate et.",
      latitude: -5.9301,
      longitude: -42.658,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "19",
      uid: "d69671c9-222a-45dd-82f9-d3cf40211bf6",
      name: "Arvid Bypass Space Center",
      description:
        "Vel excepturi quis assumenda sint aspernatur dolorem fugit sed laborum. Repellendus libero est doloremque. Rerum delectus sapiente. Quasi quia laborum rerum et soluta reprehenderit perferendis delectus.",
      latitude: 6.135,
      longitude: -131.522,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "20",
      uid: "0f78b1b9-5029-4eb7-be19-709db10ef1e8",
      name: "Runte Rapids Space Center",
      description:
        "Et veniam in est veniam sit est qui necessitatibus ut. Illo quia quo. Ab rerum voluptatum est quos nulla natus consequatur possimus. Et rerum itaque dolor in voluptatem atque in. Vero veniam odio ratione. Dolorum porro provident.",
      latitude: -24.3827,
      longitude: 132.773,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "21",
      uid: "46c81b35-f621-49a3-974f-91077baa1041",
      name: "Maddison Road Space Center",
      description:
        "Nemo eveniet quaerat esse qui ut nemo animi. Fugiat beatae molestiae. At sunt ut blanditiis.",
      latitude: -65.1444,
      longitude: -51.0751,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "22",
      uid: "ffc9b51c-4c26-421d-b76c-db706a35a35b",
      name: "Ryan Brooks Space Center",
      description:
        "Aspernatur nesciunt ea iure blanditiis nesciunt voluptas molestiae. Illum nihil delectus adipisci velit optio necessitatibus impedit. Ab dolores sint. Dolores sed repudiandae labore et maiores officiis minus. At sit ea. Sed ad et numquam.",
      latitude: -45.4628,
      longitude: -22.3351,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "23",
      uid: "d2ceae8a-361b-4837-8b38-6b73b97a2e5a",
      name: "Joaquin Wall Space Center",
      description:
        "Eos nihil aut deserunt. Non iusto numquam distinctio accusantium. Et occaecati vel temporibus aut. In est sed magnam itaque necessitatibus odio. Dolores quo quidem repudiandae debitis perspiciatis maxime. Hic saepe exercitationem consectetur at aspernatur possimus commodi rem.",
      latitude: 57.4924,
      longitude: -26.2792,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "24",
      uid: "df082993-ef71-4756-8133-5708b92860ba",
      name: "Cicero Avenue Space Center",
      description:
        "Sunt minus a eius qui modi inventore possimus voluptatum sequi. Est nam culpa. In dolorem iste voluptatem sapiente qui ut.",
      latitude: 15.8677,
      longitude: 89.908,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "25",
      uid: "42ddce41-b260-40ef-8c4a-e8bdf88952b8",
      name: "Rozella Ford Space Center",
      description:
        "Ad eos quia rerum ut voluptatem inventore inventore autem. Assumenda qui repudiandae. Ut qui quia vel. Quia cumque eius voluptatibus facere aut non enim sit dignissimos. Quos sint tempora quisquam distinctio assumenda eos voluptate iusto voluptates. Deleniti odit quidem magnam.",
      latitude: 86.6728,
      longitude: 7.0286,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "26",
      uid: "d7f7194c-44fa-4620-9957-0b05d96548e3",
      name: "Nikolaus Mount Space Center",
      description:
        "Sapiente id veniam. Doloremque possimus tempore cumque inventore. Officia et eum earum a quia perspiciatis. Sapiente nisi sit quia libero voluptas ea. Tempora autem rerum accusantium. Voluptatibus fuga debitis dolorum.",
      latitude: 44.5267,
      longitude: 3.1271,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "27",
      uid: "99e6491b-f414-42f6-8523-850bf2653c77",
      name: "Kreiger Fork Space Center",
      description:
        "In animi nesciunt consequuntur est possimus quas fuga. Reiciendis et iure ut dolorum aperiam. Sunt est maiores minima esse voluptas consequatur sed id tenetur. Et sed voluptatem nesciunt qui voluptatem quam. Repudiandae ea dolores.",
      latitude: -34.3181,
      longitude: 58.6224,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "28",
      uid: "12f7857c-cf11-4c3a-a89e-cdb21d1eee01",
      name: "Hand Canyon Space Center",
      description:
        "Omnis et perferendis et tempora eaque similique. Id nihil et qui id repellat consequatur et. Eum delectus quos eaque quisquam. Ut sunt odit odio dolor et commodi. Molestiae nam qui. Odio est at quaerat totam eligendi.",
      latitude: 1.594,
      longitude: 85.6058,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "29",
      uid: "5e6e8ab5-7e9f-4cfc-b41a-0ee8403fd660",
      name: "Gunner Roads Space Center",
      description:
        "Tempora aut nihil et asperiores et sunt iusto. Culpa est veniam beatae. Nihil dicta autem. Tempore eos quia. Cupiditate laborum est.",
      latitude: -41.4678,
      longitude: 135.743,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "30",
      uid: "d625373d-9d8a-4eec-a1b8-719f814feb0a",
      name: "Daniel Motorway Space Center",
      description:
        "Laborum ut facilis cumque omnis vitae repellendus voluptas. Aliquid rerum fugiat deserunt et modi error omnis et. Neque modi rerum non autem sed omnis possimus. Debitis aliquid unde non quibusdam aut. Aliquam atque recusandae qui voluptatum minima. Optio commodi ut aspernatur deleniti omnis non quidem quia.",
      latitude: -9.3078,
      longitude: -70.2924,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "31",
      uid: "3ad9a0cb-9f88-4178-b0e2-5c38ba900296",
      name: "Mason Roads Space Center",
      description:
        "Reprehenderit vitae error. Est natus debitis error sed voluptate laborum. Voluptatibus recusandae officia magnam et. Qui soluta non alias perspiciatis eos omnis dolores. Numquam eos et aut cumque et totam nisi.",
      latitude: 35.138,
      longitude: 176.116,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "32",
      uid: "1d13b003-f47b-46f0-829c-df5d61fd8984",
      name: "Garth Roads Space Center",
      description:
        "Cum dicta deleniti ipsam quia ea neque sunt a. Possimus accusamus repudiandae omnis earum sed porro voluptas. Eligendi mollitia ipsam inventore quidem sed esse recusandae perferendis iusto.",
      latitude: -54.5106,
      longitude: -28.7285,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "33",
      uid: "10b12c86-c44f-4e2b-b20a-b1a4a57161e9",
      name: "Claudia Key Space Center",
      description:
        "Asperiores quia quod officia quia explicabo. Velit vel quod ut officia quidem quas. Necessitatibus et in quia velit neque hic voluptatum cupiditate. Eveniet ab quia.",
      latitude: 6.1056,
      longitude: -6.6196,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "34",
      uid: "fcd66c8c-2245-400e-aa6e-8b98dbf863c9",
      name: "Gerson Cove Space Center",
      description:
        "Quae et facilis sed. Non et et. Eum quidem mollitia dolor ratione omnis natus voluptatibus doloribus suscipit. Fuga ad corporis eos. Eos dolores mollitia et. Quia veniam delectus sunt ipsa unde vitae ut ut.",
      latitude: 44.1576,
      longitude: 148.964,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "35",
      uid: "0013696d-0c87-47c1-a7cd-123b8caf94ee",
      name: "Odie Flat Space Center",
      description:
        "Aperiam dolor nihil. Aliquam neque velit et placeat itaque fugit. Sapiente cumque consequatur. Deleniti ullam impedit omnis recusandae in. Est non cumque minima iusto eius accusantium. Iste assumenda dolorum.",
      latitude: 36.8648,
      longitude: 146.78,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "36",
      uid: "d5c4d574-f91b-4c12-b046-33f166f7729a",
      name: "Joshua Fords Space Center",
      description:
        "Sint ut inventore eum neque. Enim omnis ipsa maxime voluptatem repellat quasi dolorem. Sed quis dolorum error doloremque neque quis aut assumenda temporibus. Qui quisquam rem blanditiis quisquam sit. Aut incidunt praesentium tenetur eum eum sapiente error quia placeat. Et unde eveniet est dolorem qui optio.",
      latitude: 1.2951,
      longitude: -94.4681,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "37",
      uid: "9f30a83b-d016-4cbf-990e-e33a4b1bc9d0",
      name: "Ziemann Radial Space Center",
      description:
        "Assumenda molestiae voluptatibus libero cum numquam expedita omnis. Quo et nihil. Voluptatem aut blanditiis et in et delectus. Incidunt tempore atque libero eos temporibus eius velit porro.",
      latitude: 6.5977,
      longitude: -172.635,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "38",
      uid: "cabe8c2e-3afa-4f05-b7be-4a7162ab63a1",
      name: "Freeman Club Space Center",
      description:
        "Dignissimos at officia laboriosam fuga. Illo provident maiores voluptatem vitae distinctio dolor nam dolor veritatis. Enim laudantium id cupiditate et aperiam amet eos. Optio sed sed ipsum provident qui doloribus temporibus praesentium vel. Fuga qui quia ea ut eligendi voluptas quidem sit est.",
      latitude: -49.7267,
      longitude: 67.9588,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "39",
      uid: "0aa67327-03b5-4a5a-bf00-8d587c609162",
      name: "Florida Rapid Space Center",
      description:
        "Earum perspiciatis molestiae tenetur cupiditate. Nam molestiae voluptatem quisquam consequatur et quasi nisi repudiandae omnis. Ea qui recusandae deleniti praesentium nobis iusto nobis nostrum aut. Soluta maxime assumenda ex officia consectetur aperiam at.",
      latitude: 62.9923,
      longitude: 113.172,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "40",
      uid: "ddeaecda-cf18-4460-a96f-cfb2d7cb5e48",
      name: "Wilford Trail Space Center",
      description:
        "Atque dignissimos dolorem atque accusantium. Similique quis provident eum vel vel. Quia magni quia tempora neque et autem quia. Culpa officia quo modi quos perferendis ducimus voluptas autem. Officia quibusdam eligendi consequatur sint aliquam eos iste omnis. Doloremque deserunt non modi iste ipsa nostrum.",
      latitude: -47.4911,
      longitude: -33.8324,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "41",
      uid: "d6d55454-e395-41ea-887b-fb2bd43d3ab9",
      name: "Justus Corners Space Center",
      description:
        "Est corporis incidunt ipsa laudantium. Numquam labore voluptatem ullam porro ut repellat nihil. Ipsam omnis optio quia exercitationem. Accusantium vel laboriosam. Laborum aut ut magni.",
      latitude: 48.2691,
      longitude: -163.598,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "42",
      uid: "5ecba75b-7d48-452c-9fcc-475adce5f33e",
      name: "Louvenia Meadows Space Center",
      description:
        "Magni fuga doloribus ut facere accusantium voluptas adipisci sint voluptas. Corporis omnis qui. Magni non minima molestias vero aut. Libero suscipit qui at officia aut quidem accusantium consequatur impedit.",
      latitude: 84.9842,
      longitude: 135.354,
      planet: {
        id: "1",
        name: "Mercury",
        code: "MER",
      },
    },
    {
      id: "43",
      uid: "6274e301-c38d-483a-9f8e-6bbd99f8da42",
      name: "Jacobi Drive Space Center",
      description:
        "Praesentium illum nesciunt consectetur quidem vero nihil voluptatem. Rerum quam fugiat. Vel nemo cupiditate laborum quis quos aperiam tempore eos et. Quia maxime est est totam suscipit.",
      latitude: -46.2293,
      longitude: -99.8822,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "44",
      uid: "559c3133-df03-4310-9a23-6c9c35dff599",
      name: "Stracke Ville Space Center",
      description:
        "Voluptatem quidem omnis expedita. Molestiae veritatis ratione dolores. Unde repellat ut et asperiores sequi molestiae sed. Necessitatibus quasi voluptates. Optio et reiciendis iure. Molestiae velit doloribus officia cum nemo ut.",
      latitude: 88.7095,
      longitude: 21.0119,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "45",
      uid: "0e3ede4c-e83e-4843-aff3-d5ffe3ed3554",
      name: "Deonte Rapid Space Center",
      description:
        "Sint sed nostrum ullam porro perferendis repudiandae. Eum odit error sunt. Nemo voluptas et maiores corporis. Eveniet suscipit repudiandae.",
      latitude: -19.5198,
      longitude: -111.208,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "46",
      uid: "7588a6fe-d226-4280-b314-adba2f82d225",
      name: "McKenzie Cape Space Center",
      description:
        "Recusandae est occaecati laudantium eos explicabo ex reprehenderit. Iure non est sapiente consequatur nihil. Distinctio omnis libero voluptatem accusantium dolorem aut iste sint vel. Enim labore soluta rerum qui ullam eum perferendis accusamus nihil. Voluptatibus voluptatem perspiciatis.",
      latitude: 73.4213,
      longitude: 147.658,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "47",
      uid: "bd03e47b-2e05-4833-8f65-20bfee4f6de9",
      name: "Deanna Camp Space Center",
      description:
        "Nostrum architecto eos perferendis culpa ab. Autem dolores et reprehenderit aperiam velit consequatur id provident. Perferendis voluptatum reprehenderit id eos ut.",
      latitude: -29.3794,
      longitude: -172.299,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "48",
      uid: "62bfd29a-facf-4874-ad97-2ff829eca2fe",
      name: "Krajcik Camp Space Center",
      description:
        "Ea illum quam. Illo eveniet qui rerum omnis nesciunt. Neque accusantium quod labore voluptate et enim ut consectetur et.",
      latitude: 28.1387,
      longitude: -179.186,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "49",
      uid: "a5ea6d2c-6d5d-4a58-9087-65931d84d24a",
      name: "Timmothy Pass Space Center",
      description:
        "Voluptates dolores repellat alias autem. Alias commodi totam labore non. Similique voluptatem laborum. Voluptatem quod sunt. A sint corrupti non.",
      latitude: -66.5651,
      longitude: -76.9168,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "280",
      uid: "783b672e-a112-4091-9bce-0852e3f80dfa",
      name: "Angeline Ranch Space Center",
      description:
        "Itaque sunt aut quasi cupiditate. Iusto facilis voluptate sit voluptatem est voluptatem nobis. Error eaque omnis voluptatem. Consectetur aut iusto illo distinctio officia.",
      latitude: 9.0495,
      longitude: 34.7942,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "50",
      uid: "3535cdf2-30dc-4c2b-b8d0-9fd7673e1613",
      name: "Lysanne Garden Space Center",
      description:
        "Quia ex iure consequuntur officiis et voluptas quo alias. In est rerum quae fuga. Voluptas voluptatibus non quaerat fuga. Delectus tempora cupiditate repudiandae fuga illum delectus ducimus in. Cupiditate qui maiores.",
      latitude: -15.9832,
      longitude: 53.2039,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "51",
      uid: "da2b5e50-ba23-44db-abd6-47a8f6c8dd58",
      name: "Tyreek Dale Space Center",
      description:
        "Dolores aliquid rerum voluptas qui. Quas repellat vel ducimus rerum iste vitae nihil in quis. Qui eveniet quo quis. Expedita cumque asperiores qui ratione ad cumque sapiente optio.",
      latitude: 80.8489,
      longitude: -14.2974,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "52",
      uid: "8cdc17ba-8a23-404e-8772-b4a3f19c53b5",
      name: "Devin Spurs Space Center",
      description:
        "Laudantium sint et consequatur rerum asperiores mollitia quos ad. Ullam aperiam quia recusandae exercitationem tenetur laborum maiores explicabo. Eum ut voluptatem et beatae eum et voluptatum.",
      latitude: -83.3992,
      longitude: 132.395,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "53",
      uid: "3618c2b1-555d-4972-9de8-84ffdec2c906",
      name: "Nikolaus Summit Space Center",
      description:
        "Pariatur corrupti in enim in repellat accusantium ut consequatur. Voluptatum quo aut facere sed. Fugiat ut corrupti alias libero in quia et architecto expedita. Quisquam quo qui quia eaque dicta voluptatem.",
      latitude: 61.3069,
      longitude: 159.435,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "54",
      uid: "1f2988d5-32cc-41ab-b4f5-5067ab836525",
      name: "Emmie Ferry Space Center",
      description:
        "Harum est qui. Numquam enim tempore enim est. Saepe nam facilis vero veniam. Est velit excepturi reprehenderit ex neque et. Illo eaque sapiente a facere et voluptatem quo.",
      latitude: -27.3027,
      longitude: 20.8594,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "55",
      uid: "83acf592-91eb-4258-9de2-2043055b00a7",
      name: "Heidenreich Spurs Space Center",
      description:
        "Ipsum voluptates nesciunt impedit velit consequuntur autem repellendus aut. Quasi voluptatem labore possimus est itaque. Cum atque veritatis consequatur qui architecto qui reiciendis eligendi suscipit. Aspernatur repellat ea. Veniam error ea quaerat aut odio velit. Aut perspiciatis voluptatem qui.",
      latitude: 75.7765,
      longitude: -69.1863,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "56",
      uid: "1644e73e-98d6-4852-8e69-490018324bd8",
      name: "Kilback Stream Space Center",
      description:
        "Magni vel aut maxime. Repellendus ullam rerum aut hic itaque fuga officia. Est et fugit sit non sit ut sint voluptatum. Dignissimos magni nesciunt sequi earum.",
      latitude: 58.2765,
      longitude: 24.0002,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "57",
      uid: "9443ce61-2f89-4686-b5aa-70098db1b499",
      name: "Milton Ridges Space Center",
      description:
        "Ab occaecati sit molestias. Ducimus dolorum eligendi placeat est minus. Sit ipsam vel omnis asperiores a ut occaecati. Ea dolores incidunt omnis ad numquam quas. Neque quam ab amet delectus maiores et. Nostrum nemo quae veritatis.",
      latitude: -1.3431,
      longitude: -14.8932,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "58",
      uid: "9a86d152-cc15-440c-bb20-f44c2e6295ef",
      name: "Schulist Mill Space Center",
      description:
        "In et necessitatibus veritatis inventore et. Consequatur officia ut. Sint id neque perspiciatis dolores ea incidunt.",
      latitude: -58.2899,
      longitude: -136.231,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "59",
      uid: "e26c8b63-9022-40d6-a34e-cee0abbcf104",
      name: "Florence Villages Space Center",
      description:
        "Aspernatur impedit consectetur error et nulla. Ducimus fugiat voluptatem dignissimos earum placeat quo. Totam aut voluptas voluptatibus. Enim est ut ut accusamus quasi in nostrum. Qui nostrum molestiae. Reprehenderit pariatur tenetur.",
      latitude: 12.5173,
      longitude: 132.22,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "60",
      uid: "6b78dedb-78f1-43bb-a898-01642af57a03",
      name: "Arvel Mills Space Center",
      description:
        "Sed voluptatem non aut necessitatibus deserunt voluptas magni sint. At quaerat temporibus provident ex ipsum rerum exercitationem. Quae pariatur a eveniet qui quas sint id et earum. Delectus error minus repudiandae consequuntur eaque ut temporibus. Iste enim illum veritatis architecto iusto omnis eligendi autem beatae.",
      latitude: -13.8348,
      longitude: -104.322,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "61",
      uid: "3539ed89-345b-45ab-af2a-4168b83cded4",
      name: "Emmerich Fields Space Center",
      description:
        "Ipsam aut id consequatur laudantium ut architecto. Quia repellendus fugit at voluptas. Qui est corporis error cupiditate rem.",
      latitude: -26.5559,
      longitude: 100.451,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "62",
      uid: "6e8b4c84-3d88-4964-8ca7-571e18c63138",
      name: "Owen Motorway Space Center",
      description:
        "Ut ipsam enim. Repellendus nam voluptas fugit et aut placeat rem. Quia iure sint excepturi omnis repellat nostrum et. Et provident optio porro nihil. Dolorem sit cumque.",
      latitude: 36.4382,
      longitude: -114.673,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "63",
      uid: "f321ab22-f4c0-467f-8351-64cb5e0e46af",
      name: "Rice Pike Space Center",
      description:
        "Earum tempora quas non temporibus minus error nemo. Eum quidem similique possimus. Quas error assumenda. Natus aut quos distinctio sed fugiat at debitis quidem voluptatem.",
      latitude: 68.7429,
      longitude: -73.4011,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "64",
      uid: "97c6349f-24c8-43b9-bf27-bb18cf162010",
      name: "Jakob Port Space Center",
      description:
        "Ut deleniti expedita et sed id excepturi odio autem. Officia quam est sed sed deserunt iusto. Placeat odio quia tempora et cum quis non temporibus iure. Qui aperiam molestias non ut. Ex quam recusandae cum omnis aut eveniet dolorem laudantium.",
      latitude: -26.9695,
      longitude: -119.884,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "65",
      uid: "033296b5-8a27-4510-8336-416ef03551a6",
      name: "Bria Mews Space Center",
      description:
        "Repudiandae sed temporibus id. Cum quidem possimus qui et dolorem officia laborum dignissimos. Dignissimos iste nulla nam dolor. Architecto est numquam similique. Tenetur repudiandae asperiores quia ut dolor optio qui nostrum doloribus.",
      latitude: -10.7895,
      longitude: -87.5843,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "66",
      uid: "e274bdd2-412d-4726-8dd9-723f5eeb5d9b",
      name: "Corene Springs Space Center",
      description:
        "Asperiores animi in repellendus similique ut optio occaecati delectus doloribus. Consequuntur ut sed quas cumque illum in. Dignissimos eum mollitia non impedit qui eos aut. Omnis vero quasi. Qui veniam quisquam.",
      latitude: -85.2996,
      longitude: 102.282,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "67",
      uid: "0feb5637-6c1f-4d50-9de5-c0dcfea87dcd",
      name: "Halvorson Key Space Center",
      description:
        "Deserunt dolorem rerum sequi et. Ea quaerat minus aliquam corporis mollitia quo necessitatibus. Placeat quod voluptate necessitatibus est repellat. Natus quas dolorem illo laudantium rem et sint. Explicabo ratione impedit sed. Quia eos ut ut aut.",
      latitude: -21.2698,
      longitude: 148.764,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "68",
      uid: "c7430738-5f99-47d9-80c4-8ebf205b72ec",
      name: "Ratke Locks Space Center",
      description:
        "Omnis optio recusandae dolores voluptatem ut laboriosam molestiae ut. Voluptas corporis quia ea beatae quidem facere soluta. Esse in provident et.",
      latitude: -76.3321,
      longitude: 164.703,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "69",
      uid: "2ee35e32-5058-4394-b35b-5e6598f38737",
      name: "Gino Canyon Space Center",
      description:
        "Voluptates modi aliquam dolorem quia ipsa eligendi. Id perferendis assumenda. Et dolorum et. Iste id eaque aut.",
      latitude: -11.5473,
      longitude: -155.27,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "70",
      uid: "592810fb-7dce-4bb1-ba18-9f85abb139a4",
      name: "Ferry Street Space Center",
      description:
        "Suscipit qui nihil itaque ipsam eius labore et. Sed non placeat. Optio voluptatum ut sit sit ut quas consequatur. Et in natus similique mollitia quo recusandae consequatur. Molestias pariatur temporibus nam sed molestiae repudiandae voluptatem rem. Nobis qui nihil consequatur ratione.",
      latitude: -72.8013,
      longitude: -130.735,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "71",
      uid: "5cd09e62-4d92-4d74-bd3e-6437bc8b52f4",
      name: "Zander Field Space Center",
      description:
        "Dignissimos in ipsa illo. Qui facere tempora quasi nisi aliquam non. Est tenetur optio magni odio ut laudantium ut. Pariatur et vero perspiciatis libero dolores voluptatibus tenetur et.",
      latitude: 88.6645,
      longitude: -97.7788,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "72",
      uid: "f65f0db3-8e8c-4a18-b696-814f8f6d630b",
      name: "Mauricio Mountain Space Center",
      description:
        "Quibusdam similique ut placeat magnam laudantium quas tenetur sunt. Eius et quasi eum. Sed fuga et dolor et officia.",
      latitude: 63.0275,
      longitude: -66.7666,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "73",
      uid: "469d6688-fb2d-4c7a-934f-7ca4939bca9a",
      name: "Blanda Springs Space Center",
      description:
        "Earum officia id. Est ut omnis ut iste rerum. Quasi qui quae ratione fuga iure corrupti.",
      latitude: 34.941,
      longitude: -12.4143,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "74",
      uid: "31d45f7d-7233-4c69-b8e7-a28275e4ac23",
      name: "Eichmann Burgs Space Center",
      description:
        "Voluptatum laudantium officia sit laboriosam possimus. Et dolores ea rem hic et dignissimos saepe. Impedit sit ex odit voluptatibus modi praesentium ut. Esse ducimus dolorem et vel.",
      latitude: -65.7681,
      longitude: 82.7355,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "75",
      uid: "34131ed4-6aab-4c2d-bb4b-a3989448fb1e",
      name: "Enoch Oval Space Center",
      description:
        "Quam iure quia. Reiciendis et atque consequatur ipsum quisquam ipsa. Quae sed dolorum.",
      latitude: 81.6332,
      longitude: 157.645,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "281",
      uid: "9d38a1d9-8009-4dee-be45-47345ee36246",
      name: "Garrison Dale Space Center",
      description:
        "Nulla saepe velit qui ut praesentium. Quis officia quibusdam. Explicabo quia recusandae iusto.",
      latitude: -75.5773,
      longitude: 166.213,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "76",
      uid: "11df43ee-7884-4571-b918-7330f5332f1a",
      name: "Schowalter Terrace Space Center",
      description:
        "Aut quae eos accusamus non eius perferendis et. Expedita totam doloribus quo itaque voluptatum non. Eligendi dolores quia architecto voluptate eaque et consequatur quis ut. Facere perferendis vitae. Non quia velit iusto.",
      latitude: -85.178,
      longitude: 46.2887,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "77",
      uid: "676067d6-0411-4e27-bd67-be6560ee75ab",
      name: "Wilderman Trafficway Space Center",
      description:
        "Ut ut esse consequatur molestiae cupiditate culpa nemo provident suscipit. Voluptas ipsam quia. Optio perspiciatis dolor omnis id voluptatem in. Nihil voluptate at eum qui possimus. Sapiente eos consectetur. Ea fugit commodi.",
      latitude: -85.8028,
      longitude: -73.9597,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "78",
      uid: "f09b7c48-b90c-4208-a965-c5cad3af00fd",
      name: "Ratke Throughway Space Center",
      description:
        "Exercitationem reiciendis officia rerum saepe sit vero quo assumenda et. Omnis inventore dicta deserunt. Optio voluptatum omnis voluptatum iste. Provident sunt vero. Quidem sunt numquam autem deserunt odio. Voluptatem nulla nam voluptas beatae inventore ea voluptatum velit maiores.",
      latitude: 44.8049,
      longitude: -54.7274,
      planet: {
        id: "2",
        name: "Venus",
        code: "VEN",
      },
    },
    {
      id: "79",
      uid: "93b3955d-8d86-49eb-8ce7-004899eced57",
      name: "O'Connell Estate Space Center",
      description:
        "Nihil ut exercitationem error harum tempore incidunt qui dolorem commodi. Laborum dicta cumque. Earum veniam rem dicta.",
      latitude: -31.7292,
      longitude: -16.957,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "80",
      uid: "d2b10fca-463d-4f31-86fd-f1ddf2ae5101",
      name: "Derick Parks Space Center",
      description:
        "Eveniet illo sit repellat quasi quam. Consequatur ex vitae et voluptatem sit. Iusto molestiae deserunt non consequatur qui odit. Modi molestiae eum tenetur asperiores sapiente in placeat. Quas sed fugiat natus vel vitae ex porro. Quo et rerum.",
      latitude: 33.6357,
      longitude: -49.37,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "81",
      uid: "7b40fbb4-b572-49bf-b8d3-35cbcc616b14",
      name: "Dylan Square Space Center",
      description:
        "Magni deleniti ut qui sunt consequatur quia a error. Sit quia esse. Ut sit labore dignissimos. Incidunt aut magnam sunt sit dolorem expedita voluptate ad. Occaecati ducimus modi saepe id voluptatem. Et earum id earum ipsa dolorem quod non reiciendis dolore.",
      latitude: -41.8857,
      longitude: 169.126,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "82",
      uid: "c46c4fc3-2b14-463e-bcb0-3e1cdc5db530",
      name: "Gorczany Mountains Space Center",
      description:
        "Sint optio maxime fugiat. Sit dolor iure harum sint voluptatem consectetur quos. Fugit animi ad labore autem fugit dolorem beatae perferendis. Et quis unde laborum. Unde sapiente vel non cumque quia laborum beatae at et.",
      latitude: 27.6376,
      longitude: -109.051,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "83",
      uid: "b436edd3-5e53-442b-a7cf-f527884375a4",
      name: "Ethelyn Isle Space Center",
      description:
        "Dicta et soluta non deleniti deserunt pariatur. Repudiandae rem delectus veniam optio rerum. Aut cupiditate sunt minima harum aut quis inventore quod cupiditate.",
      latitude: -75.6951,
      longitude: 46.7397,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "84",
      uid: "69682878-1c4c-4fa9-83d5-c9ff0e7a9d95",
      name: "Garrett Greens Space Center",
      description:
        "Asperiores repellat ex cum voluptatibus quis exercitationem rerum consequatur. Odit officia illum et autem. Consequatur repudiandae quo assumenda unde nobis quis enim. Rem rem totam blanditiis voluptatum eos labore et. Corrupti et iure. Ut saepe voluptates accusamus culpa.",
      latitude: -19.5228,
      longitude: 47.2494,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "85",
      uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
      name: "Marquardt Harbors Space Center",
      description:
        "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
      latitude: 34.4089,
      longitude: -164.936,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "86",
      uid: "83149b10-c534-4f61-b5da-c18e59fa5451",
      name: "Edwina Tunnel Space Center",
      description:
        "Architecto tempore eaque explicabo cum libero dicta quis culpa. Enim dolor odit vel sunt. Repudiandae ut laborum voluptate cupiditate ab debitis atque ut et. Nostrum distinctio repudiandae minima assumenda.",
      latitude: 34.8943,
      longitude: -137.755,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "87",
      uid: "f8caf4ba-0a01-42d4-90d1-425d787bfce3",
      name: "Hodkiewicz Port Space Center",
      description:
        "In aspernatur laudantium unde consectetur. Sit similique maxime rem. Cum soluta veritatis. Debitis repudiandae ut consequatur quia delectus. Aperiam eum minus voluptas nihil in nihil quidem ab blanditiis.",
      latitude: 21.8833,
      longitude: 71.5632,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "88",
      uid: "7bdead08-48c3-46e1-98ec-3c0adc722138",
      name: "Sipes Parkway Space Center",
      description:
        "Perferendis dolorem ut. Enim qui ab iure ipsum. Aliquam voluptas nam voluptatibus. Quis dolorem et repellendus sapiente et sit quibusdam.",
      latitude: 52.5147,
      longitude: -122.213,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "89",
      uid: "9b3b058f-22ac-4708-9b24-2cc33c4cedaa",
      name: "Filiberto Center Space Center",
      description:
        "Quae est numquam debitis sed saepe quia sed et. Facilis ut laboriosam aliquid quisquam. Beatae sed minus deleniti. A voluptates dolor voluptatem consectetur explicabo. Exercitationem corrupti unde alias rerum odio qui.",
      latitude: -37.3569,
      longitude: -131.923,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "90",
      uid: "12f1a0d4-c004-4175-b098-0783bf359b31",
      name: "Taurean Estate Space Center",
      description:
        "Ut praesentium quaerat harum mollitia ut est commodi est. Repellendus ipsam laudantium. Ut iusto non cum cumque maxime nam deserunt et repellat. Ipsum ut quis sunt in in aut.",
      latitude: -7.5719,
      longitude: 77.1955,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "91",
      uid: "3f66d089-e055-4851-a916-7ebc8d492e7b",
      name: "Antwon Island Space Center",
      description:
        "Rerum vitae error repellendus incidunt eum enim labore possimus non. Enim sint aut voluptates culpa delectus rerum aspernatur vero porro. Ut quia distinctio. Qui aut in saepe officia quis sed odit nisi sint. Aut sit cum harum illum aut dignissimos. Unde nostrum excepturi aut ut nam odio vel ab non.",
      latitude: -53.6565,
      longitude: 124.322,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "92",
      uid: "a818d26c-d480-49c6-8105-27d0b41537f1",
      name: "Arielle Crescent Space Center",
      description:
        "Voluptatem nulla iusto laboriosam distinctio repudiandae quibusdam qui omnis. Et deserunt atque minima voluptatem. Consectetur et excepturi quis officia nostrum quia voluptatem ipsam doloremque. Rerum aut soluta. Qui odio aperiam aut officia. Cum et maiores ut vel eum voluptas sunt magni quaerat.",
      latitude: 17.7803,
      longitude: -28.359,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "93",
      uid: "1817ef06-2703-40e7-9929-798aed5b22ab",
      name: "Daugherty Haven Space Center",
      description:
        "Sed occaecati repellendus sit distinctio suscipit rerum est. Reprehenderit a dolorum animi aut. Molestiae in sed sed quis est. Velit illo aperiam dicta quia error quo vel.",
      latitude: 39.5429,
      longitude: -136.471,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "94",
      uid: "9b83dbad-35e5-4bf1-94fe-50555c330413",
      name: "Alba Mount Space Center",
      description:
        "Earum neque sit est aut in rerum voluptas sed quod. Eum voluptatem cumque commodi sequi reprehenderit optio veritatis aut. Pariatur placeat neque. Omnis consectetur est et quo magnam qui asperiores voluptate itaque. Voluptatibus illo laudantium consectetur magnam et inventore sed. Quidem labore autem aut dolores dolorem repudiandae tempore sit odio.",
      latitude: -24.8156,
      longitude: 121.359,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "95",
      uid: "22656333-ad24-4232-8e5b-17d7cca98c88",
      name: "Hackett Rest Space Center",
      description:
        "Ut est quaerat porro aspernatur aut similique similique. Excepturi debitis mollitia maxime aperiam in eos omnis laudantium. Aut ut ut nisi. Nemo dolore est temporibus eum qui enim.",
      latitude: 36.6672,
      longitude: 0.7841,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "96",
      uid: "87646083-a4bf-4a49-bacf-d69e3399287f",
      name: "Blanda Tunnel Space Center",
      description:
        "Aut provident recusandae in dicta omnis aut. Aperiam ut ut enim. Suscipit quod praesentium aut quaerat in id dolore sunt voluptatum. Est suscipit provident.",
      latitude: 13.2983,
      longitude: 85.8202,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "97",
      uid: "02207047-8191-43e0-9912-baa36de98871",
      name: "Nova Row Space Center",
      description:
        "Omnis distinctio id ratione ullam. Non eius ea. Saepe sed ut temporibus nam. Sit eligendi minima.",
      latitude: -75.0069,
      longitude: 73.5397,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
    {
      id: "98",
      uid: "e031911f-8b82-43c9-a27b-4ade30a0a487",
      name: "Batz Estates Space Center",
      description:
        "Deserunt ut dolores optio sunt similique. Voluptatum voluptatum molestias ea ut qui qui corporis et. Consequatur numquam laborum. Officiis magnam cum quia sequi sit modi possimus.",
      latitude: -43.9401,
      longitude: 88.5139,
      planet: {
        id: "3",
        name: "Earth",
        code: "EAR",
      },
    },
  ],
  pagination: {
    total: 1538,
    page: 1,
    pageSize: 100,
  },
};

export const FLIGHTS = {
  nodes: [
    {
      id: "1",
      code: "A859703871233A5DCD7EFD20B0408DF8",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-23T07:35:16.124Z",
      seatCount: 16,
      availableSeats: 16,
    },
    {
      id: "2",
      code: "F1BBF5B3729B50C16FFC4CBAB28C8790",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-23T08:43:05.322Z",
      seatCount: 14,
      availableSeats: 14,
    },
    {
      id: "3",
      code: "22A06C0AE5BBD648515D36DFD868BA79",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-23T22:33:19.788Z",
      seatCount: 13,
      availableSeats: 13,
    },
    {
      id: "4",
      code: "09FD70C26316B53C846FC3F11A77F99A",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-23T21:25:52.320Z",
      seatCount: 29,
      availableSeats: 29,
    },
    {
      id: "5",
      code: "EE53C741D2CDB9AE2AA3997C393B043D",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-24T17:27:00.653Z",
      seatCount: 14,
      availableSeats: 14,
    },
    {
      id: "6",
      code: "685E2186F203008E182016D26DBEF11D",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-25T09:40:04.208Z",
      seatCount: 27,
      availableSeats: 27,
    },
    {
      id: "7",
      code: "D613CCCC17FFFD2B08BA05A9EB4A41BC",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-25T18:46:56.732Z",
      seatCount: 30,
      availableSeats: 30,
    },
    {
      id: "8",
      code: "5750403F901324F7514190C645B20CC3",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-27T20:40:11.716Z",
      seatCount: 14,
      availableSeats: 14,
    },
    {
      id: "9",
      code: "00190761248BF4775484824867739D19",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-27T16:09:36.294Z",
      seatCount: 34,
      availableSeats: 34,
    },
    {
      id: "10",
      code: "905F3ACAD36F2B6BA19DFD5FC5E96FEC",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-28T13:49:32.519Z",
      seatCount: 11,
      availableSeats: 11,
    },
    {
      id: "11",
      code: "C87CE28387149280C45654E42BC20A44",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-28T17:09:28.828Z",
      seatCount: 10,
      availableSeats: 10,
    },
    {
      id: "12",
      code: "0F7B569FC7ED57410A35B35346D72E52",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-29T09:58:27.468Z",
      seatCount: 31,
      availableSeats: 31,
    },
    {
      id: "13",
      code: "8F589C2541F2135FB3C11D9B3C944F35",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-29T18:55:00.036Z",
      seatCount: 17,
      availableSeats: 17,
    },
    {
      id: "14",
      code: "C49E34E2674BA731F3F54FAB09BF089F",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-29T19:18:56.723Z",
      seatCount: 14,
      availableSeats: 14,
    },
    {
      id: "15",
      code: "F88347101B593378FD783C348475EFA7",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-30T09:39:16.351Z",
      seatCount: 34,
      availableSeats: 34,
    },
    {
      id: "16",
      code: "A9777D92F1BD18DB2E6EE77E22F260AC",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-09-30T10:05:53.680Z",
      seatCount: 13,
      availableSeats: 13,
    },
    {
      id: "17",
      code: "F14C5CA681FBC91AB06AEFB657F20A99",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-10-01T20:39:23.589Z",
      seatCount: 28,
      availableSeats: 28,
    },
    {
      id: "18",
      code: "0B7B85EFDACE63CAFCE3E86779F40CE9",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-10-02T06:45:58.022Z",
      seatCount: 29,
      availableSeats: 29,
    },
    {
      id: "19",
      code: "E9FF4F8D039A7760CA85D540602B4980",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-10-02T13:30:00.264Z",
      seatCount: 33,
      availableSeats: 33,
    },
    {
      id: "20",
      code: "3B8EC02A2B680A3A1A363189BF1480D6",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-10-02T21:52:59.944Z",
      seatCount: 25,
      availableSeats: 25,
    },
    {
      id: "21",
      code: "15B7BEDD5CB3FBF7A6CDF51A5AEB40BF",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-10-04T21:57:25.746Z",
      seatCount: 33,
      availableSeats: 33,
    },
    {
      id: "22",
      code: "C30B949362D63897D91DB40747C58FF5",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-10-04T08:51:43.647Z",
      seatCount: 23,
      availableSeats: 23,
    },
    {
      id: "23",
      code: "85C7D095A348611851E892FF23296F84",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-10-04T15:40:35.454Z",
      seatCount: 10,
      availableSeats: 10,
    },
    {
      id: "24",
      code: "28C31DC4C7F702FF344CF5D82A053CFB",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-10-05T09:39:12.455Z",
      seatCount: 24,
      availableSeats: 24,
    },
    {
      id: "25",
      code: "35DB7BC23D5C3498218E91A24C779369",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "11",
        uid: "2bdf187f-adfb-4ce9-8a60-b24d0c4102ae",
        name: "Schiller Brook Space Center",
        description:
          "Quam ad voluptatem aut consequatur. Cupiditate quasi quisquam. Asperiores odio est. Maxime nihil corrupti assumenda similique magni aut. Nemo modi et. Animi deleniti quisquam in repudiandae quod repellendus maiores fuga.",
        latitude: 82.8725,
        longitude: 71.6412,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      departureAt: "2019-10-07T13:37:15.959Z",
      seatCount: 36,
      availableSeats: 36,
    },
    {
      id: "26",
      code: "0E53F2456FC988B0F00782D5DAA04342",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-23T18:26:39.099Z",
      seatCount: 24,
      availableSeats: 24,
    },
    {
      id: "27",
      code: "255173D93FDE797398153353E88CAA5E",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-23T13:00:54.194Z",
      seatCount: 29,
      availableSeats: 29,
    },
    {
      id: "28",
      code: "44C34C1DD26351FF23A9B13AD2C46BA9",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-24T11:32:28.720Z",
      seatCount: 23,
      availableSeats: 23,
    },
    {
      id: "29",
      code: "E834AABA590814A388AB57ADF908C3C7",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-24T18:37:58.494Z",
      seatCount: 11,
      availableSeats: 11,
    },
    {
      id: "30",
      code: "9C1754B59A9C5252003056D4210280F7",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-24T15:46:11.112Z",
      seatCount: 22,
      availableSeats: 22,
    },
    {
      id: "31",
      code: "4D0A2B826772AD9E4AD272259F40C1D8",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-25T21:49:14.851Z",
      seatCount: 38,
      availableSeats: 38,
    },
    {
      id: "32",
      code: "91C54BCEDB9FE6A0E9A06930CCB92471",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-26T15:15:16.712Z",
      seatCount: 23,
      availableSeats: 23,
    },
    {
      id: "33",
      code: "2EE8C554BA20758A116AC18FC6453707",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-26T21:14:19.189Z",
      seatCount: 35,
      availableSeats: 35,
    },
    {
      id: "34",
      code: "C7625CF300E2D300ABD45F420D6A677A",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-27T16:53:55.414Z",
      seatCount: 28,
      availableSeats: 28,
    },
    {
      id: "35",
      code: "2130230EB8BE798E4B49271B8749C348",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-27T17:42:34.512Z",
      seatCount: 13,
      availableSeats: 13,
    },
    {
      id: "36",
      code: "72119B1544980B547FC2A91B617BC622",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-27T09:28:35.842Z",
      seatCount: 16,
      availableSeats: 16,
    },
    {
      id: "37",
      code: "2279BE036EB889A2EF7F854C94C7D590",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-27T16:35:00.124Z",
      seatCount: 19,
      availableSeats: 19,
    },
    {
      id: "38",
      code: "806BE628FBC370C75180CC0A5A1C3338",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-28T20:48:37.899Z",
      seatCount: 13,
      availableSeats: 13,
    },
    {
      id: "39",
      code: "41F207B1BF9EDF82E69FCB62C4706F3B",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-29T14:58:18.938Z",
      seatCount: 27,
      availableSeats: 27,
    },
    {
      id: "40",
      code: "C4F4989079B4CCD0738F1BFB6B3903E0",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-29T13:38:37.090Z",
      seatCount: 25,
      availableSeats: 25,
    },
    {
      id: "41",
      code: "F43BAC5C759E3A52C20F397116F93C3E",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-30T23:38:35.545Z",
      seatCount: 19,
      availableSeats: 19,
    },
    {
      id: "42",
      code: "D32F32B98970433A94D1D249F0ED262C",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-30T20:06:15.574Z",
      seatCount: 36,
      availableSeats: 36,
    },
    {
      id: "43",
      code: "60FE775465EEA4C03A8700933631E7E2",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-02T11:58:18.185Z",
      seatCount: 26,
      availableSeats: 26,
    },
    {
      id: "44",
      code: "1C2703B23716142CB7FDD2C3C7DF3009",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-02T21:17:35.068Z",
      seatCount: 32,
      availableSeats: 32,
    },
    {
      id: "45",
      code: "AC60A52EB7749E571AB6073B172DCDDC",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-02T10:42:05.116Z",
      seatCount: 18,
      availableSeats: 18,
    },
    {
      id: "46",
      code: "8F3091270928E583DB96716659B8B218",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-02T07:32:44.056Z",
      seatCount: 14,
      availableSeats: 14,
    },
    {
      id: "47",
      code: "5C06906930FE9AAC2E300E8342546828",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-03T06:12:03.521Z",
      seatCount: 25,
      availableSeats: 25,
    },
    {
      id: "48",
      code: "A9E6CF22BD20AFFF33CB6DC7AB47ADE1",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-03T12:25:52.487Z",
      seatCount: 13,
      availableSeats: 13,
    },
    {
      id: "49",
      code: "1E392E2168A2EDC857B5CA5B3198E6E7",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "85",
        uid: "cc2adab2-3eaa-41ff-8d22-50d055c75048",
        name: "Marquardt Harbors Space Center",
        description:
          "Commodi quas vel quia nam culpa aliquam praesentium harum iure. Saepe distinctio et voluptas exercitationem omnis magni libero et. Est sed tenetur sit voluptas magni velit a porro. Repellat et voluptatem dolor. Tempora cumque aut impedit modi tempora veritatis sint. Omnis minus ipsam deleniti corrupti est consequatur neque.",
        latitude: 34.4089,
        longitude: -164.936,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-07T20:20:14.688Z",
      seatCount: 13,
      availableSeats: 13,
    },
    {
      id: "50",
      code: "ADD056E83C575E43D46D0BE5ADE6EC2E",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-23T14:51:11.380Z",
      seatCount: 36,
      availableSeats: 36,
    },
    {
      id: "51",
      code: "A96D314A3F1566EADDB9B7F78160BEB4",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-24T08:06:35.725Z",
      seatCount: 23,
      availableSeats: 23,
    },
    {
      id: "52",
      code: "F86936603E27ECC8934CAE5BEA86CA4B",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-24T21:51:51.462Z",
      seatCount: 29,
      availableSeats: 29,
    },
    {
      id: "53",
      code: "0B62BCEE6BABA65985F04AD168898044",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-24T17:57:28.402Z",
      seatCount: 10,
      availableSeats: 10,
    },
    {
      id: "54",
      code: "542C6E63AD5B0BF78477222DE6C5C2AC",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-25T06:28:18.623Z",
      seatCount: 23,
      availableSeats: 23,
    },
    {
      id: "55",
      code: "36C3D4DD02FE71C39FC6E7754990372C",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-25T17:09:38.839Z",
      seatCount: 14,
      availableSeats: 14,
    },
    {
      id: "56",
      code: "244E2D6AE73EB522BB537DB542911A10",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-25T06:21:19.097Z",
      seatCount: 13,
      availableSeats: 13,
    },
    {
      id: "57",
      code: "8F6B90D720D6935A9D44FCBC47BF515F",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-25T12:08:01.918Z",
      seatCount: 25,
      availableSeats: 25,
    },
    {
      id: "58",
      code: "9986F0E1C870015A3942A3C1355C0E91",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-27T23:39:12.290Z",
      seatCount: 35,
      availableSeats: 35,
    },
    {
      id: "59",
      code: "FEAC5D5A9BF30473F13D7C14EF9A874C",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-29T09:36:49.239Z",
      seatCount: 38,
      availableSeats: 38,
    },
    {
      id: "60",
      code: "FA9B3735FAA5C61676A44B8825F51605",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-29T15:36:47.314Z",
      seatCount: 35,
      availableSeats: 35,
    },
    {
      id: "61",
      code: "E96AF62DB534F54D51ABCFEC563C7DB4",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-30T09:17:57.729Z",
      seatCount: 35,
      availableSeats: 35,
    },
    {
      id: "62",
      code: "620DB4F5C6691A85D67076C2EFC05D83",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-30T14:34:42.522Z",
      seatCount: 12,
      availableSeats: 12,
    },
    {
      id: "63",
      code: "554CF253BE6587010F63B4283C047961",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-30T12:44:25.039Z",
      seatCount: 25,
      availableSeats: 25,
    },
    {
      id: "64",
      code: "87AC9779E3B31E884757C8890C3D751A",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-01T10:31:01.147Z",
      seatCount: 25,
      availableSeats: 25,
    },
    {
      id: "65",
      code: "52407448090E29BCA00C826E54396489",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-01T17:27:06.513Z",
      seatCount: 33,
      availableSeats: 33,
    },
    {
      id: "66",
      code: "2C5DD889A89F1D973E3A7A9B1B186798",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-01T12:52:47.809Z",
      seatCount: 36,
      availableSeats: 36,
    },
    {
      id: "67",
      code: "934575A34C19275042A7F388A84383C9",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-01T13:35:56.890Z",
      seatCount: 31,
      availableSeats: 31,
    },
    {
      id: "68",
      code: "58014087E33563C1F32A348DAEAEA0DB",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-03T09:37:23.187Z",
      seatCount: 12,
      availableSeats: 12,
    },
    {
      id: "69",
      code: "4B23A639AFC0AAE99D33C7F09CE78718",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-05T19:40:45.888Z",
      seatCount: 25,
      availableSeats: 25,
    },
    {
      id: "70",
      code: "07E21FA9367D14F21DA5DBAE3E637861",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-07T10:37:58.273Z",
      seatCount: 19,
      availableSeats: 19,
    },
    {
      id: "71",
      code: "81D057EBF0D2A05F085D1EDF2AF8FE43",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "99",
        uid: "5616537a-350b-4ec2-9d26-233ac4a2127f",
        name: "Rohan Wells Space Center",
        description:
          "Et vero quas voluptatem id quia. Nobis illum veritatis est pariatur et qui. Saepe aut voluptate eligendi est itaque perferendis iure voluptate. Sunt rem sit sint et voluptatem ad aut. Vel quos officiis. Sit sed ad voluptatem doloribus temporibus est dicta et.",
        latitude: 77.7737,
        longitude: -85.3215,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-07T21:28:14.104Z",
      seatCount: 31,
      availableSeats: 31,
    },
    {
      id: "72",
      code: "60001DCEDBDB49B3C6C1AACFF7F0C5B4",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-23T12:34:17.561Z",
      seatCount: 16,
      availableSeats: 16,
    },
    {
      id: "73",
      code: "438EBE87BFE37E9E68D6FCAF86496722",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-23T19:51:31.990Z",
      seatCount: 12,
      availableSeats: 12,
    },
    {
      id: "74",
      code: "25ABFB765F73C24FA0DF01C331054405",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-23T17:13:17.037Z",
      seatCount: 34,
      availableSeats: 34,
    },
    {
      id: "75",
      code: "33E1E25C9FBB24649FA6E6B6EB0D1C7C",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-24T22:03:22.250Z",
      seatCount: 29,
      availableSeats: 29,
    },
    {
      id: "76",
      code: "EB958D06C6E7A5FCD603A9B48D5E979C",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-24T10:36:00.374Z",
      seatCount: 12,
      availableSeats: 12,
    },
    {
      id: "77",
      code: "C2BA301CB7B210532150E482FC3CF209",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-25T14:42:00.746Z",
      seatCount: 21,
      availableSeats: 21,
    },
    {
      id: "78",
      code: "1FCA9F9812515EC1E1A63B5DA4123E3F",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-25T11:45:36.400Z",
      seatCount: 31,
      availableSeats: 31,
    },
    {
      id: "79",
      code: "86644C3BE177B7927BC18215DBC5AE50",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-25T07:02:44.178Z",
      seatCount: 32,
      availableSeats: 32,
    },
    {
      id: "80",
      code: "8F0889A6A00F9DF8DC9DB279A54EBBD5",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-26T14:01:12.104Z",
      seatCount: 11,
      availableSeats: 11,
    },
    {
      id: "81",
      code: "782C279D96C40E6EED7BCA37041A1783",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-26T18:30:00.738Z",
      seatCount: 31,
      availableSeats: 31,
    },
    {
      id: "82",
      code: "931826EF0CD7DA4C10ACEFC622402D9D",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-26T16:59:22.772Z",
      seatCount: 16,
      availableSeats: 16,
    },
    {
      id: "83",
      code: "BCC8648E829A17BD93A4CDE5A4CFCCA7",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-27T06:29:44.946Z",
      seatCount: 39,
      availableSeats: 39,
    },
    {
      id: "84",
      code: "5672C9A5362463806D6C081DDA8323B3",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-27T12:30:02.531Z",
      seatCount: 27,
      availableSeats: 27,
    },
    {
      id: "85",
      code: "D9C0B8D80DDF8CA34D285C9756AD3F9A",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-27T06:28:39.266Z",
      seatCount: 32,
      availableSeats: 32,
    },
    {
      id: "86",
      code: "D3CE9849D8FE47C1BE60D4256A5A2892",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-28T14:25:41.228Z",
      seatCount: 11,
      availableSeats: 11,
    },
    {
      id: "87",
      code: "6E356975C3DFE0F3C0488E846EE80B5E",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-28T20:50:33.731Z",
      seatCount: 15,
      availableSeats: 15,
    },
    {
      id: "88",
      code: "9E3BD13C898DF913441350F518C4A855",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-28T20:43:52.184Z",
      seatCount: 37,
      availableSeats: 37,
    },
    {
      id: "89",
      code: "0E25B0752ABD545AD0C10B419D42A59D",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-28T08:51:39.257Z",
      seatCount: 20,
      availableSeats: 20,
    },
    {
      id: "90",
      code: "BA853432CB9D888F030984BC1B244898",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-30T14:01:15.061Z",
      seatCount: 24,
      availableSeats: 24,
    },
    {
      id: "91",
      code: "4FAFFED5B2D1B98A7492BCBE60C836DB",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-30T08:50:29.891Z",
      seatCount: 26,
      availableSeats: 26,
    },
    {
      id: "92",
      code: "B583F98DC2078DA66282E10EF110031D",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-09-30T10:46:06.962Z",
      seatCount: 23,
      availableSeats: 23,
    },
    {
      id: "93",
      code: "C388317C67245887169464F13B6CC20E",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-01T10:17:58.704Z",
      seatCount: 34,
      availableSeats: 34,
    },
    {
      id: "94",
      code: "9519D67A90DFE9FEB5C0A6F4F1BFC686",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-01T09:03:58.499Z",
      seatCount: 33,
      availableSeats: 33,
    },
    {
      id: "95",
      code: "DD32A0A7B4BE5A8320D39D17C5B39356",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-01T06:53:10.953Z",
      seatCount: 13,
      availableSeats: 13,
    },
    {
      id: "96",
      code: "0292B8C9ACD0CEC5EABE56CCAA6D2580",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-01T07:34:47.120Z",
      seatCount: 25,
      availableSeats: 25,
    },
    {
      id: "97",
      code: "4B9413A5F30A27184A9FF50986B9B28B",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-02T23:21:09.328Z",
      seatCount: 26,
      availableSeats: 26,
    },
    {
      id: "98",
      code: "0A01AB3D3AB59D1815186EEC7A90CF8E",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-03T18:03:55.544Z",
      seatCount: 14,
      availableSeats: 14,
    },
    {
      id: "99",
      code: "65E8ABD230072ABAB2F57F1644DB49F2",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-03T10:35:08.372Z",
      seatCount: 15,
      availableSeats: 15,
    },
    {
      id: "100",
      code: "8F6A87CFA372ACA3AB94043D59D8D527",
      launchSite: {
        id: "1",
        uid: "43216729-26d4-470c-ba3b-d76aff894bb1",
        name: "Schmitt Hills Space Center",
        description:
          "Qui ipsum ut molestiae cum ut vel fuga aut. Rerum quo numquam. Sed consequatur quis. Omnis voluptatem nemo eligendi dolorum id et ab nulla unde. Illo omnis eum omnis ea. Atque est voluptas est omnis odio.",
        latitude: 86.3067,
        longitude: 163.565,
        planet: {
          id: "1",
          name: "Mercury",
        },
      },
      landingSite: {
        id: "106",
        uid: "a9dbac4d-b1ea-4db2-b978-080214fd50e1",
        name: "Richmond Trace Space Center",
        description:
          "Ea iusto quidem earum ut animi. Facilis inventore qui porro accusamus eos aut facere atque id. Assumenda est explicabo ipsam dignissimos molestiae. Mollitia nobis voluptas quis sequi esse et blanditiis quod et.",
        latitude: -71.2774,
        longitude: 151.863,
        planet: {
          id: "3",
          name: "Earth",
        },
      },
      departureAt: "2019-10-04T22:52:50.581Z",
      seatCount: 22,
      availableSeats: 22,
    },
  ],
};
